import { render } from "./userArticle.vue?vue&type=template&id=3184f2db&scoped=true"
import script from "./userArticle.vue?vue&type=script&lang=js"
export * from "./userArticle.vue?vue&type=script&lang=js"

import "./userArticle.vue?vue&type=style&index=0&id=3184f2db&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3184f2db"]])

export default __exports__